import React, { useState, useEffect, useContext } from 'react';

import './Charsheet01.css'

import Charsheet0 from '../../components/Charsheet0';

import { UserDataContext } from "../../App.js";

import CharsheetFull from '../../components/CharsheetFull';
import CharsheetLandscape from '../../components/CharsheetLandscape.js';
import Spell from '../../components/Spell';
import LOAD_CHAR from '../../components/Charsheet0/helpers/load_char2.js'
import flatten from '../../components/Charsheet0/helpers/flatten.js'


// ----------------------------------------------------------------------------------
//                         Description
//
//     Charsheet01 displays the data for a single character in letter-page format
//     - It is optimized for printing to a sheet of letter paper
//     - Intended for desktop display
//     - shows both the character sheet (charsheetFull), and the spells detail window
//
//     Parents: 
//           - pages/Charsheet05.js
//              - pages/Home.js
//                  - App.js
//
//     Children:
//           - components/CharsheetFull.js
//           - components/CharsheetLandscape.js
//           - components/Spell.js
//
//      Data:
//            -> data = props.data = main character data, passed from Charsheet05
//            - uses setData to load data using currentChar from props.state[0]
//
//     (c) DXA Development 2024
// ----------------------------------------------------------------------------------

function Charsheet01(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------

    // props.state = globalstate = [ currentChar, setChar, loggedIn, layout, setLayout, currentSpellArray, currentSpellDataArray ]
    
    var currentChar = props.state[0];
    var setChar = props.state[1];

    const layout = props.state[3];
    console.log('Charsheet01 layout:', layout);

    const [ currentSpell, setCurrentSpell ] = props.state[5];
    const [ currentSpellData, setCurrentSpellData ] = props.state[6];

    var data = props.data;
    var setData = props.setdata;
    var charID = props.charID || 'char0';
    var spellCheckArray=props.spellCheckArray;

    const [userData, setUserData] = useContext(UserDataContext);

    // -------- local state variables --------
    
    var loadAttempts = 0;

    // ------------- useEffect ---------------

    useEffect( () => {

        async function DoSomething () { 
            
            loadAttempts += 1;
        
            let charData
            if (loadAttempts < 2) {
                console.log("Charsheet 01 load attempt ", loadAttempts);
                const result = await LOAD_CHAR( currentChar, setChar, false, userData, 'Charsheet 01' );
                charData = result.data;

                const flatCharData = flatten(charData, 'Charsheet01')

                // set character data
                setData( flatCharData );
          
                // set spell check data
                if (spellCheckArray) {
                  /* v0.4
                  for (let i=1; i<=5; i++) {
                    for (let j=1; j<=10; j++) {
                      const idx = (i)*10 + (j)
                  */
                  // v0.5
                  for (let i=1; i<=9; i++) {
                    for (let j=1; j<=30; j++) {
                      const idx = (i-1)*30 + (j-1)
                      const spellCheckVarName = "mySpk" + String(i) + String(j).padStart(2, '0')
            
                      // the second item in the Array is the update function
                      let updateSpellCheck = spellCheckArray[idx][1]
                      
                      const spellChecksThis = flatCharData[spellCheckVarName]
                      
                      // set the data if it exists
                      if (typeof spellChecksThis !== 'undefined') {
                        updateSpellCheck( spellChecksThis )
            
                      } else {
                      // set to Empty if no data
                        
                        updateSpellCheck(['Empty','Empty','Empty','Empty','Empty','Empty'])
                      }
                   }   
                  }
                }
              
            }

            // set page title
            if ( currentChar === 'Welcome to ADM' ) {
                document.title = 'Advanced Dungeon Master'
    
            } else {
            document.title = 'ADM: ' + currentChar; 
            };

            console.log('Charsheet01 UPDATE',charData);

        }

        DoSomething();

    }, [ currentChar, setChar, setData ]); //useEffect

    // ---------- handler functions ----------


    // ---------- return html (jsx) ----------
    const showNew = true;


    // <Charsheet0 {...props} spellUpdaters = { [setCurrentSpell, setCurrentSpellData] } />   <= the original charsheet. RIP


    return (
        <>
        { layout === 'landscape' ? (
          <CharsheetLandscape state={props.state} data={ data } setdata={ setData } charID={ charID } 
            spellUpdaters = { [setCurrentSpell, setCurrentSpellData]} spellCheckArray={spellCheckArray} 
            activeViewArray={props.activeViewArray}/>
          ) : (
          <CharsheetFull state={props.state} data={ data } setdata={ setData } charID={ charID } 
            spellUpdaters = { [setCurrentSpell, setCurrentSpellData]} spellCheckArray={spellCheckArray}
            activeViewArray={props.activeViewArray} />
       ) }
        
        <Spell spellname={ currentSpell } spelldata={ currentSpellData } />
        </>
        )

    };  // end of function

    export default Charsheet01